export const getUTMs = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    utm_source: params.get("utm_source") || "website",
    utm_medium: params.get("utm_medium") || "organic",
    utm_campaign: params.get("utm_campaign") || "no_campaign",
    utm_adgroup: params.get("utm_adgroup") || "default_adgroup",
    utm_term: params.get("utm_term") || "default_term",
    utm_content: params.get("utm_content") || "default_content",
    gclid: params.get("gclid") || "",
    fbclid: params.get("fbclid") || "",
  };
};
